import React, { useState } from 'react';
import axios from "axios";
import { Link } from 'react-router-dom';
import GolferAuthLayout from './GolferAuthLayout';

const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [loading, setLoading] = useState(false);

  const handleForgotPassword = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await axios.post('https://lionfish-app-w73zu.ondigitalocean.app/api/password_reset/', { email });
      setMessage("If the email exists, a reset link has been sent.");
    } catch (error) {
      console.error("Password reset request failed:", error);
      setMessage("An error occurred while requesting password reset.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <GolferAuthLayout
      seoTitle="Forgot Password — PrivateIQ"
      seoDescription="Reset your PrivateIQ account password."
      canonicalPath="/forgot-password"
    >
      <div className="ga-auth-card">
        <div className="ga-auth-badge">Account Recovery</div>
        <h1 className="ga-auth-title">Forgot Password?</h1>
        <p className="ga-auth-subtitle">
          Enter the email associated with your account and we'll send you a reset link.
        </p>
        <form onSubmit={handleForgotPassword} className="ga-auth-form">
          <input
            className="ga-auth-input"
            type="email"
            placeholder="Enter your email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
          <button type="submit" className="ga-auth-btn" disabled={loading}>
            {loading ? "Sending..." : "Send Reset Link"}
          </button>
          {message && (
            <p className={message.includes("error") ? "ga-auth-error" : "ga-auth-message"}>
              {message}
            </p>
          )}
        </form>
        <div className="ga-auth-links">
          <p>
            Remembered your password? <Link to="/login">Login</Link>
          </p>
          <p>
            Forgot your username? <Link to="/forgot-username">Recover Username</Link>
          </p>
        </div>
      </div>
    </GolferAuthLayout>
  );
};

export default ForgotPassword;
